import { VideoFlowState } from './types';

export const isYoutubeMostReplayedObjectiveSelector = (state: VideoFlowState) =>
  state.objective === 'YouTubeMostReplayed';

export const youtubeEmbedVideoIdSelector = (state: VideoFlowState) =>
  state.mediaImportedArgs?.provider === 'youtube'
    ? state.mediaImportedArgs.videoId
    : undefined;

export const selectedClipDurationMillisSelector = (state: VideoFlowState) =>
  Math.max(
    0,
    (state.clipEndMillis ?? state.clipStartMillis) - state.clipStartMillis,
  );

export const audioDurationMillisSelector = (state: VideoFlowState) =>
  state.objective === 'SingleClip'
    ? selectedClipDurationMillisSelector(state)
    : state.suggestedClipDurationMillis;

export const shouldSkipDestinationForImportedMediaSelector = (
  state: VideoFlowState,
) => !!state.useYoutubeMostReplayed;

export const shouldShowVideoSizeRecommendationSelector = (
  state: VideoFlowState,
) => state.objective !== 'MultipleClips';

export const shouldShowNoMostReplayedDataMessageSelector = (
  state: VideoFlowState,
) =>
  isYoutubeMostReplayedObjectiveSelector(state) &&
  state.mediaImportedArgs?.provider === 'youtube' &&
  !state.useYoutubeMostReplayed;
